<template functional>
    <span class="text-uppercase">
        <b-badge v-if="props.portalAccess === 'full'" key="portal-full" variant="soft-success" class="">Active</b-badge>
        <b-badge v-else-if="props.portalAccess === 'open_invite'" key="portal-invited" variant="soft-primary" class="">Open Invite</b-badge>
        <b-badge v-else-if="props.portalAccess === 'expired_invite'" key="portal-invite-expired" variant="soft-warning" class="">Expired Invite</b-badge>
        <b-badge v-else-if="props.portalAccess === 'on_hold'" key="portal-on-hold" variant="soft-danger" class="">Deactivated</b-badge>
        <b-badge v-else-if="props.portalAccess === 'none'" key="portal-none" variant="soft-secondary" class="">No Access</b-badge>
        <b-badge v-else-if="props.portalAccess === 'invite_ready'" key="portal-invite-ready" variant="soft-info" class="">Invite Ready</b-badge>
        <b-badge v-else key="portal-empty-string" variant="soft-secondary">No Access</b-badge>
    </span>
</template>

<script>

export default {
    functional: true,
    name: 'TuPortalAccessBadge',
    props: {
        portalAccess: {  // should be something like 'full', 'open_invite', etc. from the TU serializer... empty string gets 'No Access', 
            type: String,
            required: true,
        }
    },
}
</script>

<style>

</style>